import { useId, cloneElement, type ReactElement, type ReactNode } from 'react'
import { Icon } from './Icon.js'

export interface FieldProps {
  /** Usually plain text; a node so a required marker can ride along with it. */
  label: ReactNode
  help?: string
  error?: string
  children: ReactElement<{ id?: string; 'aria-describedby'?: string; 'aria-invalid'?: boolean }>
}

export function Field({ label, help, error, children }: FieldProps) {
  const id = useId()
  const messageId = `${id}-message`

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      {cloneElement(children, {
        id,
        'aria-describedby': help || error ? messageId : undefined,
        'aria-invalid': error ? true : undefined,
      })}
      {error ? (
        <p
          id={messageId}
          role="alert"
          className="row"
          style={{ gap: 6, marginTop: 'var(--space-1)', fontSize: 12, color: 'var(--color-danger)' }}
        >
          <Icon name="Warning" size={14} />
          {error}
        </p>
      ) : help ? (
        <p id={messageId} className="text-muted" style={{ marginTop: 'var(--space-1)', fontSize: 12 }}>
          {help}
        </p>
      ) : null}
    </div>
  )
}
